import { defineComponent, reactive, watch, ref } from 'vue';
import { EnvironmentOutlined } from '@ant-design/icons-vue';
import { LoginService } from '@/services/login.service';
import { UserService } from '@/services/user.service';
import { useService } from '@kaokei/use-vue-service';
import VCode from '@/components/VCode.vue';
import ImageCode from '@/components/ImageCode.vue';
import { logger, phonePattern, imageCodePattern, setToken } from '@/utils';
import { debounce } from 'lodash-es';
export default defineComponent({
  name: 'LoginDialogMobile',
  components: {
    VCode: VCode,
    ImageCode: ImageCode,
    EnvironmentOutlined: EnvironmentOutlined
  },
  setup: function () {
    var userService = useService(UserService);
    var loginService = useService(LoginService);
    var formRef = ref();
    var agreementItemRef = ref(null);
    var formState = reactive({
      phone: '',
      imageCode: '',
      code: '',
      agreement: false
    });
    var formRules = reactive({
      phone: [{
        required: true,
        message: '请输入手机号',
        trigger: 'blur'
      }, {
        pattern: phonePattern,
        message: '手机号不正确',
        trigger: 'blur'
      }],
      imageCode: [{
        required: true,
        message: '请输入图片验证码',
        trigger: 'blur'
      }, {
        pattern: imageCodePattern,
        message: '图片验证码不正确',
        trigger: 'blur'
      }],
      code: [{
        required: true,
        message: '请输入短信验证码',
        trigger: 'blur'
      }]
    });
    var onSubmit = debounce(function () {
      if (formRef && formRef.value) {
        formRef.value.validate().then(function () {
          var _a;
          if (!formState.agreement) {
            if (agreementItemRef.value) {
              (_a = agreementItemRef.value.classList) === null || _a === void 0 ? void 0 : _a.add('shake');
            }
            return;
          }
          return loginService.loginByMobile(formState.phone, formState.code).then(function (res) {
            setToken(res.token);
            return userService.initUserInfo().then(function () {
              loginService.hideLoginDialog();
              loginService.queryGoToEnvCheckDialog();
            });
          });
        }).catch(function (e) {
          logger.debug('提交登录表单失败 => ', e);
        });
      }
    }, 500);
    // 监听登录弹窗是否关闭
    watch(function () {
      return loginService.visible;
    }, function (visible) {
      if (!visible) {
        formRef.value.resetFields();
      }
    });
    var onAnimationEnd = function (ev) {
      var target = ev.target;
      target === null || target === void 0 ? void 0 : target.classList.remove('shake');
    };
    return {
      labelCol: {
        span: 0
      },
      wrapperCol: {
        span: 24
      },
      formRef: formRef,
      formState: formState,
      formRules: formRules,
      onSubmit: onSubmit,
      loginService: loginService,
      onAnimationEnd: onAnimationEnd,
      agreementItemRef: agreementItemRef
    };
  }
});